export default {
    red: "#FF000D",
    green: "#1F7000",
    white: "#ffffff",
    grey: "#4d4d4d"
}